export enum AppMode {
  DCASH_RECOVERY = "DCASH_RECOVERY",
  NORMAL = "NORMAL",
}
